const light = {
  id: 'light',
  displayName: 'Light',
  baseType: 'light',
  enabled: true,
  linkedPalette: null,
  ui: {
    headerBg: '#f8f9fa', headerText: '#000000', accentColor: '#0d6efd',
    mainBg: '#bdcecf', mainText: '#000000', mainTextHeading: '#16213e',
    mainHeroText: '#FFFFFF', footerBg: '#f8f9fa', footerText: '#000000',
    cardBg: '#FFFFFF', cardText: '#000000', cardBorder: 'dimgray',
    cardButtonBg: '#0d6efd', cardButtonText: '#FFFFFF',
    navLinkText: '#000000', navLinkHover: '#0d6efd', navLinkActive: '#B86E00',
    listGroupBg: '#bdcecf', bmrkDetailBg: 'dimgray',
    bmrkMetricBg: '#FFFFFF', bmrkMetricText: '#000000', bmrkMetricBorder: '#000000',
    mainCardText: '#000000', navLinkFocus: '#000000', navEmailActive: '#000000',
    homeProseLabel: '#0d6efd', homeProseLink: '#0d6efd', homeProseDlBtn: '#0d6efd',
    cardButtonBorder: 'dimgray', linkColor: '#0d6efd', cardTextMuted: '#666666',
  },
};
export default light;
